import React from 'react';
import { useTranslation } from 'react-i18next';
import { BulkImportResult as BulkImportResultData } from '@/types/api';
import './BulkImportResult.scss';

interface BulkImportResultProps {
  result: BulkImportResultData;
  onDismiss?: () => void;
}

/** Outcome of a bulk import: how many rows were created and, per
 * spreadsheet row, why the others were not. */
const BulkImportResult: React.FC<BulkImportResultProps> = ({ result, onDismiss }) => {
  const { t } = useTranslation();
  const hasErrors = result.errors.length > 0;

  return (
    <div className={`bulk-import-result ${hasErrors ? 'bulk-import-result--with-errors' : ''}`} role="status">
      <div className="bulk-import-result__header">
        <strong>{t('bulkImportResult.created', { count: result.created })}</strong>
        {onDismiss && (
          <button type="button" className="bulk-import-result__dismiss" onClick={onDismiss} aria-label={t('common.close')}>
            ×
          </button>
        )}
      </div>
      {hasErrors && (
        <>
          <p className="bulk-import-result__errors-title">
            {t('bulkImportResult.errorsTitle', { count: result.errors.length })}
          </p>
          <ul className="bulk-import-result__errors">
            {result.errors.map((error, index) => (
              <li key={`${error.row}-${index}`}>
                <span className="bulk-import-result__row">{t('bulkImportResult.row', { row: error.row })}</span>
                {error.message}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default BulkImportResult;
